export const SOLICITUDINDI_LOADING = 'SOLICITUDINDI_LOADING';
export const SOLICITUDINDI_LOADED = 'SOLICITUDINDI_LOADED';
export const SOLICITUDINDI_ERROR = 'SOLICITUDINDI_ERROR';

export const SOLICITUD_LOADING = 'SOLICITUD_LOADING';
export const SOLICITUD_LOADED = 'SOLICITUD_LOADED';
export const SOLICITUD_ERROR = 'SOLICITUD_ERROR';

export const SOLICITUDCREAR_LOADING = 'SOLICITUDCREAR_LOADING';
export const SOLICITUDCREAR_LOADED = 'SOLICITUDCREAR_LOADED';
export const SOLICITUDCREAR_ERROR = 'SOLICITUDCREAR_ERROR';

export const SOLICITUDEDITAR_LOADING = 'SOLICITUDEDITAR_LOADING';
export const SOLICITUDEDITAR_LOADED = 'SOLICITUDEDITAR_LOADED';
export const SOLICITUDEDITAR_ERROR = 'SOLICITUDEDITAR_ERROR';

export const SOLICITUDELIMINAR_LOADING = 'SOLICITUDELIMINAR_LOADING';
export const SOLICITUDELIMINAR_LOADED = 'SOLICITUDELIMINAR_LOADED';
export const SOLICITUDELIMINAR_ERROR = 'SOLICITUDELIMINAR_ERROR';